/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = parseInt(this.dataset.max, 10) || 3;
      this.products = '';
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof(recentIds) !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }
    connectedCallback() {
      this.buildUrl();
    }
    buildUrl() {
      let i = 0;
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += 'handle:' + val + ' OR ';
        i++;
      });

      this.url = this.url + encodeURIComponent(this.products);

      this.fetchProducts();
    }
    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add('product-recommendations--loaded');
            this.addWishlistButtons();
          }

        })
        .catch(e => {
          console.error(e);
        });
    }
    addWishlistButtons() {
      // The Wishlist King app only scans the initial page HTML, so cards loaded
      // via this AJAX fetch never receive a heart. Inject one per card the same
      // way the app would (it defines the <wishlist-button-collection> element).
      this.querySelectorAll('.product-card .product-featured-image').forEach((wrap) => {
        if (wrap.querySelector('wishlist-button-collection, wk-button')) {
          return;
        }
        const link = wrap.querySelector('a[href*="/products/"]');
        if (!link) {
          return;
        }
        const handle = link.getAttribute('href').replace(/^.*\/products\//, '').split('?')[0].split('/')[0];
        const button = document.createElement('wishlist-button-collection');
        button.setAttribute('data-product-handle', handle);
        button.setAttribute('floating', '');
        button.setAttribute('show-icon', '');
        wrap.prepend(button);
      });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}